// extracted by mini-css-extract-plugin
export default {"divider":"TaxData_divider__rsIeI"};